export default __webpack_public_path__ + "static/media/logoblanco.b2da97cc.png";